import { TextField } from "@mui/material";
import * as React from "react";

export default function Others() {
  return <TextField multiline rows={10} fullWidth />;
}
